import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=5edadced&scoped=true"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=5edadced&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edadced",
  null
  
)

export default component.exports